export const getHighestBidder = (players?: IPlayer[]) => {
  return (
    players?.find((player) =>
      players?.every(
        (playerInner) =>
          (playerInner.auctionData?.bid ?? 0) <
            (player.auctionData?.bid ?? 0) || player.order === playerInner.order
      )
    ) || players?.[0]
  )
}
